import axiosServices from './request';

const exercisebook = axiosServices('exercisebook');

export default {
  /** 检查是否理工校友 */
  checkWhutAlumni: exercisebook('get', 'VIPUser/checkWhutAlumni'),
  //根据code获取详情
  getByCode: exercisebook('get', 'getByCode'),
  // 根据code领取权益
  receive: exercisebook('get', 'receive'),
  // 获取banner
  getBannerList: exercisebook('get', 'user/getBannerList'),
  /** 获取通用参数 */
  getCommonConfigByCode: exercisebook('get', 'user/getCommonConfigByCode'),
  /** 获取用户信息(小睿伴学的用户信息) */
  getUserInfo: exercisebook('get', 'user/getUserInfo'),
  /** 获取所有滚动购买信息 */
  getAllVipBuyList: exercisebook('get', 'VIPRollContent/getAllList'),
  /** 获取权益列表 */
  getRightsList: exercisebook('get', 'VIPRights/listRights'),
  // 学期卡购买页-获取最新活动
  getLastSemesterActivity: exercisebook('get', 'VIPActivity/getLastActivity'),
  /** 获取vip列表 */
  getVIPList: exercisebook('get', 'VIPLevel/getVIPList'),
  // 学期卡支付
  placeOrder4Activity: exercisebook('post', 'payment4IOS/placeOrder4Activity'),
  // ios实物发货
  payMent4IOSPay: exercisebook('post', 'payment4IOS/pay'),
  // 学期卡活动详情权益页-获取活动信息
  getVIPActivityById: exercisebook('get', 'VIPActivity/getById'),
  // 学期卡支付购买前-检测用户是否可以购买
  checkUserBuyPermission: exercisebook('get', 'VIPActivity/checkUserBuyPermission'),
  // 获取用户当前优惠券列表
  getCouponList: exercisebook('get', 'coupon/getCouponList'),
  // 获取配置内容
  getContentByType: exercisebook('get', 'contentSetting/getContentByType'),
  // 购买成功页
  getPayResultPageUrl: exercisebook('get', 'payResultPage/getPayResultPageUrl'),
  /** 抖音RAYS码跳转判断 */
  getDouyinAppUrl: exercisebook('get', 'user/getDouyinAppUrl'),
  /** 课程书刊订单 */
  listUserDownloadOrder4H5: exercisebook('get', 'user/listUserDownloadOrder4H5'),
  /** H5下载书刊配置资源详情 */
  getBookResourceDTOByBookId: exercisebook('get', 'bookBase/getBookResourceDTOByBookId'),
  /** h5落地页 */
  getFunction4H5: exercisebook('get', 'homeFunction/getFunction4H5'),
  /** bookid查书刊信息 */
  getBookById: exercisebook('get', 'book/getBookById'),
  /** 书籍埋点 */
  addLearnBookRecord: exercisebook('post', 'user/addLearnBookRecord'),
  // 查询书籍来源
  getBookBaseSourceByBookId: exercisebook('get', 'bookBase/getBookBaseSourceByBookId'),
  // 小睿伴学-我的书架
  getLearnRecently: exercisebook('get', 'user/getLearnRecently'),
  // 小睿伴学-根据手机号获取用户信息
  getUserInfoByPhone: exercisebook('get', 'user/getUserInfoByPhone'),
  // 购买页-获取最新活动
  getLastActivity: exercisebook('get', 'VIPActivity/getLastActivity'),
  // 获取活动信息
  getActivityById: exercisebook('get', 'VIPActivity/getById'),
  // 查询用户是否关注
  getIsSubscribe: exercisebook('post', 'reportSubscribe/isSubscribe'),
  //根据bookId查询订单信息
  getOrderByBookId: exercisebook('get', 'book/getOrderByBookId')
};
